import React from "react";
import { Typography, Link, Breadcrumbs } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./breadcrumbview.module.scss"; 
import {titleCase} from "../Utill/Utills";
import { labelArray } from "./BreadcrumbLabels";

const BreadcrumbView = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const  location  = useLocation();

  const pathnames = pathname.split("/").filter(Boolean);
  if(pathnames.length <=0){
    return null;
  }

  const getLableFromRouteName = (rName) =>{
    let myLabel = labelArray.find((o)=> o.name == rName);
    //TODO: if label not found with route name

    if(myLabel != null && myLabel.name == 'details'){
      return location.state.eName;
    }

    if(myLabel != null){
      return myLabel.value;
    }
   
    return rName;
  }
  
  return (
    <Breadcrumbs className={classes.breadcrumb} >
       {pathnames.length ? (
        <Link onClick={() => navigate("/")}>Home</Link>
      ) : (
        <Typography> Home </Typography>
      )}
      {pathnames && pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <Typography key={name}>{titleCase(getLableFromRouteName(name))}</Typography>
        ) : (
          <Link key={name} onClick={() => navigate(routeTo)}>
            {titleCase(getLableFromRouteName(name))}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbView;